import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/dhl-luggage-shipping.jpg'),
    alt: 'dhl luggage shipping page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'dhl luggage shipping page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'DHL <span> Luggage Shipping Services</span><span>Fast and Secure</span>',
  description:
    'ShipAndStorage offers fast, reliable, and affordable DHL Luggage Shipping solutions, making international travel stress-free. Enjoy seamless door-to-door luggage delivery with secure handling, real-time tracking, and competitive pricing—so you can travel light and worry-free.',
  image: {
    url: '/images/v2/pages/landing-pages/dhl-luggage-shipping/hero-image.jpg',
    alt: 'DHL  Luggage Shipping Services Fast and Secure'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Sign Up for DHL Luggage Shipping' }
}

export const ourProcessSectionContent = {
  title: 'Secure and Fast DHL Luggage Shipping',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Arrange Your Pickup' },

  image: {
    url: '/images/v2/pages/landing-pages/dhl-luggage-shipping/secure-and-fast-dhl-luggage-shipping.png',
    alt: 'Secure and Fast DHL Luggage Shipping'
  },

  articles: [
    {
      id: 1,
      title: 'Easy Online Booking',
      description:
        'Quickly schedule your shipment online in minutes, select your options, and get instant tracking details for a smooth booking experience.',
      image: {
        src: '/images/v2/pages/common/easy-online-booking2.png',
        alt: 'Easy Online Booking'
      }
    },
    {
      id: 2,
      title: 'Safe Handling and Pickup',
      description:
        'Our DHL professionals ensure secure handling from pickup to delivery, using strict safety protocols and advanced packaging for protection throughout transit.',
      image: {
        src: '/images/v2/pages/common/safe-handling-and-pickup.png',
        alt: 'Safe Handling and Pickup'
      }
    },
    {
      id: 3,
      title: 'Fast and Reliable Delivery',
      description:
        'With DHL’s global network, your luggage is delivered safely and on time to over 220+ countries, giving you dependable service whether for business or pleasure.',
      image: {
        src: '/images/v2/pages/common/fast-and-reliable-delivery.png',
        alt: 'Fast and Reliable Delivery'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Affordable DHL Luggage Shipping Services',
  description:
    'Tired of paying high airline baggage fees? ShipAndStorage’s DHL Luggage Shipping services provide a cost-effective and convenient alternative. Our pricing is transparent and competitive, ensuring you get the best value.',
  image: {
    src: '/images/v2/pages/landing-pages/dhl-luggage-shipping/affordable-dhl-luggage-shipping-services.jpg',
    alt: 'Affordable DHL Luggage Shipping Services'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of International Luggage Shipping Services',

  cards: [
    {
      id: 1,
      title: 'Convenience',
      description:
        'Traveling without carrying heavy luggage makes your journey stress-free. With door-to-door delivery, you avoid long waits at baggage claim and customs. Our service ensures a smooth experience from departure to arrival.',
      image: {
        src: '/images/v2/pages/common/easy-access-and-convenience.png',
        alt: 'Convenience'
      }
    },
    {
      id: 2,
      title: 'Cost-Effective',
      description:
        'Avoid expensive airline baggage fees and overweight charges by using a dedicated shipping service. With competitive pricing and no hidden costs, you save money while ensuring safe and reliable luggage transportation.',
      image: {
        src: '/images/v2/pages/common/affordable-shipping-options.png',
        alt: 'Cost-Effective'
      }
    },
    {
      id: 3,
      title: 'Reliable Tracking',
      description:
        'DHL’s advanced tracking system provides real-time updates on your shipment. You can monitor your luggage’s journey at every stage, from pickup to final delivery, ensuring complete peace of mind.',
      image: {
        src: '/images/v2/pages/common/real-time-tracking.png',
        alt: 'Reliable Tracking'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose Us for DHL Luggage Shipping?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Frequent Travelers',
          description:
            'Avoid airport baggage claims and airline restrictions by shipping your luggage in advance. Our service allows business and leisure travelers to enjoy a seamless travel experience without worrying about lost or delayed baggage.'
        },
        {
          id: 2,
          title: 'Students Moving Abroad',
          description:
            'Studying in another country comes with the challenge of transporting personal belongings. Our DHL Luggage Shipping services provide an easy and secure solution for students moving internationally, ensuring their essentials arrive safely at their new location.'
        },
        {
          id: 3,
          title: 'Business Professionals',
          description:
            'Shipping work materials, trade show equipment, and business essentials can be time-sensitive. Our fast and secure shipping solutions ensure that business travelers receive their important items on schedule, reducing travel-related stress.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/dhl-luggage-shipping/who-should-choose-us-for-dhl-luggage-shipping.jpg',
        alt: 'Who Should Choose Us for DHL Luggage Shipping?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Different Shipping Services',
  description:
    'ShipAndStorage offers a wide range of international shipping options to meet your unique needs. Explore our specialized services below:',

  cards: [
    {
      id: 1,
      title: 'Luggage Shipping',
      description:
        'Our DHL Luggage Shipping service allows travelers to send their suitcases and bags safely worldwide. With secure pickup, efficient transport, and timely delivery, we ensure a hassle-free experience for all international travelers.',
      image: {
        src: '/images/v2/pages/common/luggage-shipping-services.png',
        alt: 'Luggage Shipping'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Golf Club Shipping',
      description:
        'Avoid the hassle of carrying bulky golf equipment to your destination. We offer a dedicated shipping service that ensures your golf clubs arrive safely and on time, allowing you to focus on your game.',
      image: {
        src: '/images/v2/pages/common/Golf-Club-Shipping.png',
        alt: 'Golf Club Shipping'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Moving Box Shipping',
      description:
        "For individuals and families relocating, we provide safe and cost-effective solutions for moving boxes. Our service ensures your belongings arrive securely, whether you're moving across the country or overseas.",
      image: {
        src: '/images/v2/pages/common/specialty-item-shipping.png',
        alt: 'Moving Box Shipping'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Ski and Snowboard Shipping',
      description:
        'Shipping ski and snowboard equipment eliminates the inconvenience of transporting them through airports. Our reliable service ensures your gear is delivered directly to your resort or accommodation, making winter travel easier.',
      image: {
        src: '/images/v2/pages/common/sports-equipment-storage.png',
        alt: 'Ski and Snowboard Shipping'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for DHL Luggage Shipping?',

  image: {
    url: '/images/v2/pages/landing-pages/dhl-luggage-shipping/why-choose-shipandstorage-for-dhl-luggage-shipping.jpg',
    alt: 'Why Choose ShipAndStorage for DHL Luggage Shipping?'
  },

  articles: [
    {
      id: 1,
      title: 'Global Reach',
      description:
        'Ship luggage to over 220 countries with DHL’s trusted international shipping network. Our global presence ensures your items reach any destination securely and on time.'
    },
    {
      id: 2,
      title: 'Affordable Rates',
      description:
        'We offer cost-effective shipping solutions that help you save on expensive airline baggage fees. Our transparent pricing and flexible options make international luggage shipping accessible to all.'
    },
    {
      id: 3,
      title: 'Secure Handling',
      description:
        'Every package is handled with care and follows strict safety protocols. From pickup to delivery, our team ensures your luggage remains well-protected throughout transit.'
    },
    {
      id: 4,
      title: '24/7 Tracking',
      description:
        'Stay informed with real-time shipment monitoring through DHL’s advanced tracking system. Our online tracking tools allow you to check the status of your luggage at any time.'
    },
    {
      id: 5,
      title: 'Timely Delivery',
      description:
        'Our efficient logistics system guarantees on-time luggage delivery. We minimize transit delays, ensuring your shipment arrives as scheduled, no matter what the destination.'
    },
    {
      id: 6,
      title: 'Reliable Customer Support',
      description:
        'Our dedicated support team is available to assist with any shipping inquiries. Whether you need booking assistance or shipment updates, we provide expert guidance.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'DHL Luggage Shipping Services Fast And Reliable',
  description:
    'DHL luggage shipping services available now. Secure, fast, and affordable solutions for shipping your luggage with DHL.',
  image: {
    src: '/images/v2/pages/landing-pages/dhl-luggage-shipping/dhl-luggage-shipping-services-fast-and-reliable.png',
    alt: 'DHL Luggage Shipping Services Fast And Reliable'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Start Shipping' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Storage Partners',
  description:
    'At ShipAndStorage, we collaborate with leading logistics providers to deliver top-notch storage and shipping solutions.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx is a global logistics leader, dedicated to safely storing and transporting your belongings.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of this information. For further details, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL offers secure and reliable logistics services, providing safe storage and transport for your items, especially during the busy summer months.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS specializes in secure storage solutions and comprehensive global shipping, ensuring your items are handled with care at every stage.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of this information. For more details, visit <a href='https://www.ups.com' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
